<template>
  <page :title="$tc('ads.ads')+' / '+$tc('view')">
    <div class="box">
      <filters @input="filters => adsViewsContents.filter(filters).load()"></filters>

      <hr />

      <div class="card-content is-paddingless">
        <b-table
          :data="adsViewsContents.data"
          :loading="adsViewsContents.loading"
          paginated
          backend-pagination
          pagination-position="bottom"
          :current-page="adsViewsContents.current_page"
          :per-page="adsViewsContents.per_page"
          :total="adsViewsContents.total"
          @page-change="page => adsViewsContents.changePage(page)"
          backend-sorting
          @sort="(field, direction) => adsViewsContents.sort(field, direction)"
          :default-sort="['created_at', 'desc']"
          class="is-middle"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="Id" sortable width="80">{{ props.row.user.id }}</b-table-column>

            <b-table-column field="name" :label="$tc('userName')">{{ props.row.user.name}}</b-table-column>

            <b-table-column field="type" label="Ad Name">
              <div v-if="props.row.page != null">{{ props.row.page.name}}</div>
              <div class="has-text-grey" v-else>Unknown</div>
            </b-table-column>

            <b-table-column field="created_at" label="Created">
              <b-tooltip :label="props.row.created_at">
                <span>{{ calculated(props.row.created_at) }}</span>
              </b-tooltip>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
import moment from "moment";
import Filters from "./Filters";
export default {
  components: {
    Filters
  },

  data() {
    return {
      adsViewsContents: new window.PaginatedRemoteCollection(
        "/admin/api/ads-views/index"
      )
    };
  },

  created() {
    this.adsViewsContents.load();
  },

  methods: {
    search(search) {
      this.adsViewsContents.filter({ search }).load();
    },
    calculated(created) {
      return moment(created).fromNow();
    }
  }
};
</script>
